import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { useFuncId } from "../../router/menuRouterMapper";
import { checkLoading, SystemLoading } from "../../store/loadingStore";
import { handleSuccessMessage, MessageContext } from "../../store/messageStore";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { queryRoleUserGroupList, updateRoleUserGroupList } from "../../utility/service/personal-service";
import { checkDpSuccess, getMaskedString } from "../../utility/service/tool-service";
import SelectGroupTable from "./SelectGroupTable";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { Dropdown } from "primereact/dropdown";
import { AcctContext } from "../../utility/useReduce/userNameReduce";

/***
 * F2020202 
 * roleSeq
 * userSeqList (群組使用者)
[]
 * **/
const RoleGroup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setItemObj, itemObj } = useOutletContext();
  const [item1, setItem1] = useState([]);
  const [item2, setItem2] = useState([]);
  const [unassignedList, setUnassignedList] = useState([]);
  const [roleUserList, setRoleUserList] = useState([]);
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();
  const isEditable = useEditableFlag("F202"); // Get editable status for F202 function
  const [approverList, setApproverList] = useState([]);
  const [approveModel, setApproveModel] = useState(null);
  const [approveModelList, setApproveModelList] = useState([]);
  // 簽核標記
  const approveFlag = state?.approveFlag;
  const isTopLevelRole = !itemObj?.parentId;
  const canShowApproveSetting = approveFlag && (isTopLevelRole || !itemObj?.last);

  const addOrRemove = (action) => {
    if (action === "add") {
      let excludeKey2Array = item2?.map((obj) => obj.userSeq);
      setRoleUserList((pre) => {
        return [...pre, ...item2];
      });
      //   //將已選擇的項目 從 unassignedList 移除
      let excludeArr2 = unassignedList?.filter((item) => !excludeKey2Array?.includes(item.userSeq));
      setUnassignedList(excludeArr2);
      setItem2([]);
    } else {
      //移除
      let excludeKey1Array = item1?.map((obj) => obj.userSeq);
      setUnassignedList((pre) => {
        return [...pre, ...item1];
      });
      let excludeArr1 = roleUserList?.filter((item) => !excludeKey1Array?.includes(item.userSeq));
      setRoleUserList(excludeArr1);
      setItem1([]);
    }
  };

  const axios_queryRoleUserGroupList = useCallback(
    (roleSeq) => {
      //取得角色群組清單
      checkLoading(loading);
      queryRoleUserGroupList({ roleSeq })
        .then((res) => {
          if (checkDpSuccess(res)) {
            setRoleUserList(res?.data?.RespBody?.roleUserList);
            setUnassignedList(res?.data?.RespBody?.unassignedList);
            setApproveModel(res?.data?.RespBody?.approveModel);
            const approveModelList = res?.data?.RespBody?.roleUserList
              .filter((item) => item.approver)
              .map((item) => item.userSeq);
            setApproverList(approveModelList);
          }
        })
        .finally(() => checkLoading(loading, false));
    },
    [loading],
  );

  useEffect(() => {
    axios_getSubItemsByItemNo("APPROV_MODEL", 52).then(setApproveModelList);
  }, []);

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  useEffect(() => {
    if (JSON.stringify(itemObj) === "{}") {
      navigate("/management/rolePermission");
    } else {
      axios_queryRoleUserGroupList(itemObj?.roleSeq);
    }
  }, [itemObj, axios_queryRoleUserGroupList, navigate]);

  useEffect(() => {
    if (approverList?.length <= 1) {
      setApproveModel("sequential");
    } else {
      if (approveModel === "sequential") {
        setApproveModel("");
      }
      setApproveModelList((pre) =>
        pre.map((item) => (item.subitemNo === "sequential" ? { ...item, disabled: true } : item)),
      );
    }
  }, [approverList]);

  const handleUpdateUserList = () => {
    let reqBody = {
      roleSeq: itemObj?.roleSeq,
      approveModel: approveModel,
      userSeqList: roleUserList?.map((item) => item?.userSeq),
      approverList: roleUserList?.filter((item) => approverList.includes(item?.userSeq)).map((item) => item?.userSeq),
    };
    axios_updateRoleUserGroupList(reqBody);
  };

  const axios_updateRoleUserGroupList = (reqBody) => {
    checkLoading(loading);
    updateRoleUserGroupList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
          navigate("/management/rolePermission", { state: { roleSeq: itemObj?.roleSeq } });
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  const masKAccountTemplate = (rowData, props) => {
    if (rowData) {
      return <>{!maskView ? getMaskedString("account", rowData?.[props?.field]) : rowData?.[props?.field]}</>;
    }
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "V",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  return (
    <>
      {/* 返回列表 */}
      <div className="align-items-start">
        <Button
          rounded
          text
          onClick={() => {
            navigate("/management/rolePermission");
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
          {t("button.return_to_list")}
        </Button>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <div className="grid">
            <div className="col-12">
              <label className="font-semibold mr-3">{t("role_symbol")}</label>
              <span>{itemObj?.symbol}</span>
            </div>
            <div className="col-12">
              <label className="font-semibold mr-3"> {t("role_name")}</label>
              <span>{itemObj?.name}</span>
            </div>
          </div>
          <hr />
          <div className="grid">
            <div className="col-6">
              <div>
                {canShowApproveSetting && (
                  <>
                    <label htmlFor="approveModel" className="form-label required">
                      {t("approveModel")}
                    </label>
                    <Dropdown
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={approveModel}
                      disabled={approverList?.length <= 1}
                      options={approveModelList}
                      className={`w-full `}
                      onChange={(e) => {
                        setApproveModel(e.value);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="col-6 flex justify-content-end align-items-center">
              <Button
                type="button"
                icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
                severity="secondary"
                onClick={() => {
                  setMaskView((prev) => {
                    if (!prev) {
                      axios_updateAuditEyesEvent();
                    }
                    return !prev;
                  });
                }}
              />
            </div>
            <div className="col-12 lg:col-6 ">
              {/* 移除 */}
              <div className="p-card">
                <div className="p-card-body">
                  <label className="font-bold">{t("group_user")}</label>
                  <hr />
                  <SelectGroupTable
                    masKAccountTemplate={masKAccountTemplate}
                    dataList={roleUserList}
                    item={item1}
                    setItem={setItem1}
                    disabled={!isEditable}
                    crownDisplay={canShowApproveSetting}
                    approverList={approverList}
                    setApproverList={setApproverList}
                    approveFlag={approveFlag}
                  />
                  <div className="text-center">
                    <Button
                      onClick={() => {
                        addOrRemove("remove");
                      }}
                      className="mt-2"
                      disabled={item1?.length === 0 || !isEditable}
                      severity="danger"
                      type="button"
                      label={t("button.remove")}
                      size="small"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 加入 */}
            <div className="col-12 lg:col-6">
              <div className="p-card">
                <div className="p-card-body">
                  <label className="font-bold">{t("ungroup_user")}</label>
                  <hr />
                  <SelectGroupTable
                    masKAccountTemplate={masKAccountTemplate}
                    dataList={unassignedList}
                    item={item2}
                    setItem={setItem2}
                    disabled={!isEditable}
                  />
                  <div className="text-center">
                    <Button
                      onClick={() => {
                        addOrRemove("add");
                      }}
                      className="mt-2"
                      disabled={item2?.length === 0 || !isEditable}
                      type="button"
                      label={t("button.add_in")}
                      size="small"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 gap-2 flex-all-center">
            <Button
              disabled={!isEditable || !(!approveFlag || approveModel)}
              onClick={() => {
                handleUpdateUserList();
              }}
              type="button"
              label={t("button.update")}
              size="small"
            />
            <Button
              outlined
              size="small"
              label={t("button.cancel")}
              onClick={(e) => {
                e.preventDefault();
                setItemObj({});
                navigate("/management/rolePermission");
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleGroup;
